// Currency Exchanges Vuex

import state from './exchangeStates.js'
import * as getters from './exchangeGetters.js'
import * as mutations from './exchangeMutations.js'
import * as actions from './exchangeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
